import React, { useState } from "react";

const Search = ({ search, setInput }) => {
  const inputHandler = (e) => {
    setInput(e.target.value);
  };

  return (
    <div className="search">
      <input
        className="input"
        onChange={inputHandler}
        type="text"
        name=""
        id=""
      />
      <button onClick={search}>搜尋</button>
    </div>
  );
};

export default Search;
